import {
  Box,
  Button,
  Card,
  CardMedia,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { db, functions } from "../../firebase.config";

import Iconify from "../Iconify";

import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import Timer from "./Timer";
import { UserAuth } from "../../context/AuthContext";
import Modal from "@mui/material/Modal/Modal";
import Backdrop from "@mui/material/Backdrop/Backdrop";
import Fade from "@mui/material/Fade/Fade";
import { Variables } from "../../context/VariableContext";
import { httpsCallable } from "firebase/functions";
import CustomButton from "../CustomButton";
import { checkPromoCode, initiatePay } from "../api/api";
import { shortNumber } from "../util/formatNumber";
import Cookies from "js-cookie";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
};

export default function ReserDesktop({
  event,
  montant,
  ticketsList,
  seance,
}) {
  var randomstring = require("randomstring");
  const { openReservation, setOpenReservation } = Variables();
  const { user } = UserAuth();

  const navigate = useNavigate();
  const { eventID } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [loadingF, setLoadingF] = React.useState(false);
  const [total, setTotal] = React.useState(montant);
  const [nomField, setNom] = React.useState("");
  const [discountField, setDiscount] = React.useState("");
  const [reduction, setReduction] = React.useState();
  const [addCode, setAddCode] = React.useState(false);
  const [codeCheck, setCodeCheck] = React.useState({});
  const [prenomField, setPrenom] = React.useState("");
  const [emailField, setEmail] = React.useState("");
  const [confirmEmailField, setConfirmEmail] = React.useState("");
  const [fieldError, setError] = React.useState(false);
  const [confirmError, setConfirmError] = React.useState(false);
  const [fee, setFee] = React.useState(0);
  const [moyenPaie, setMoyenpaie] = React.useState(0);

  const handleRadioChange = (event) => {
    var tmp = event.target.value;
    if (parseInt(tmp) === 0) {
      setFee(0)
    } else if (parseInt(tmp) === 1) {
      setFee(1.5)
    } else {
      setFee(2.5)
    }
    setMoyenpaie(parseInt(event.target.value));
  };

  const setPaymentWay = (value) => {
    var tmp = value;
    if (parseInt(tmp) === 0) {
      setFee(0)
    } else if (parseInt(tmp) === 1) {
      setFee(1.5)
    } else {
      setFee(2.5)
    }
    setMoyenpaie(parseInt(value));
  };

  useEffect(() => {
    (async () => {
      try {
        setLoadingF(true);
        console.log(seance)
        const docRef0 = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef0);
        if (docSnap.exists()) {
          setEmail(docSnap.data().email);
          setNom(docSnap.data().nom);
          setPrenom(docSnap.data().prenom);
          setConfirmEmail(docSnap.data().email);
          console.log("start");
          // setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
      setLoadingF(false);
    })();
  }, []);

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
    return null;
  }
  const getLocationFromCookies = () => {
    const location = Cookies.get("userLocation");
    return location ? JSON.parse(location) : null;
  };
  //fonction de paiement
  const pay = async () => {
    setLoading(true);
    var montant = 0;
    if (nomField === "" || prenomField === "" || emailField === "") {
      setError(true);
      setLoading(false);
      return;
    }
    if (emailField !== confirmEmailField) {
      setConfirmError(true);
      setLoading(false);
      return;
    }
    const affiliate = getCookie(`affId-${eventID}`);
    const location = getLocationFromCookies();
    const source = 'Direct'
    console.log(reduction)
    try {
      const addMessage = httpsCallable(functions, "initiatePay");
      const result = await addMessage({ tickets: ticketsList, uid: user ? user.uid : null, firstname: prenomField, lastname: nomField, mobile: '', email: emailField, eventid: eventID, from: 1, discount: reduction, fee: fee, seance: seance, track: affiliate ? { aff: affiliate } : null, location: location, source: source });
      console.log("-----------------result payment----------------")
      console.log(result.data)
      if (result.data?.status === 'ok') {
        const url = result.data.link; // "/fr/event/12345"
        const parts = url.split("/"); // ["", "fr", "event", "12345 
        const billId = parts[parts.length - 1];
        console.log('facture')
        console.log(billId)
        Cookies.set(`billId`, billId, { expires: 1 });
        window.location.href = result.data.link
      } else {
        setLoading(false);
        //window.location.replace(`http://localhost:3001/fr/event/${eventID}?order=unavalable`)
        // window.location.replace(`https://choptonticket.com/fr/event/${eventID}?order=unavalable`)
        // navigate(`/fr/event/${eventID}?stateOrder=unavalable`)

      }
    } catch (error) {
      console.log(error)
      setLoading(false);
      navigate(`/fr/event/${eventID}?stateOrder=unavalable`)
    }
  };

  //fonction de paiement
  const payV2 = async () => {
    setLoading(true);
    var montant = 0;
    if (nomField === "" || prenomField === "" || emailField === "") {
      setError(true);
      setLoading(false);
      return;
    }
    if (emailField !== confirmEmailField) {
      setConfirmError(true);
      setLoading(false);
      return;
    }
    const affiliate = getCookie(`affId-${eventID}`);
    const location = getLocationFromCookies();
    const source = 'Direct'
    console.log(reduction)
    try {
      console.log()
      const payload = {
        uid: user?.uid,
        tickets: ticketsList,
        firstname: prenomField,
        lastname: nomField,
        mobile: "",
        email: emailField,
        eventid: eventID,
        from: 1,
        discount: reduction,   // ton objet promo
        fee,
        seance,
        track: affiliate,       // tracking affilié
        location,
        source,
        version: 1
      };

      // 🔥 Important : il faut le await ici !!!
      const result = await initiatePay(payload);
      console.log("-----------------result payment----------------")
      console.log(result.data)
      if (result.data?.status === 'ok') {
        const url = result.data.link; // "/fr/event/12345"
        const parts = url.split("/"); // ["", "fr", "event", "12345 
        const billId = parts[parts.length - 1];
        console.log('facture')
        console.log(billId)
        Cookies.set(`billId`, billId, { expires: 1 });
        window.location.href = result.data.link
      } else {
        setLoading(false);
        window.location.replace(`http://localhost:3001/fr/event/${eventID}?order=unavalable`)
        // window.location.replace(`https://choptonticket.com/fr/event/${eventID}?order=unavalable`)
        // navigate(`/fr/event/${eventID}?stateOrder=unavalable`)

      }
    } catch (error) {
      console.log(error)
      setLoading(false);
      window.location.replace(`http://localhost:3001/fr/event/${eventID}?order=unavalable`)
    }
  };
  const [procedCheckCP, setProcedCheckCP] = React.useState(false);
  const handleVerifyPromoCode = async () => {
    let response
    try {
      setLoading(true)
      setProcedCheckCP(true)
      response = await checkPromoCode(eventID, discountField, ticketsList);
      console.log(response.discount)
      setReduction(response.discount);
      setCodeCheck({ valid: true, message: response.message, })

    } catch (error) {
      setCodeCheck({ valid: false, message: 'code non valide ou expiré', })
    } finally {
      setLoading(false)
      setProcedCheckCP(false)
    }

  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        /* height: "80%",
        width: "65%", */
        // height: 670,
        height: { xs: 200, sm: '90%', md: 670 },
        // width:980,
        width: { xs: '95%', sm: '95%', md: 980 },
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Stack spacing={3} justifyContent={'center'} alignItems={'center'}>
              <Typography variant="h6"
                fontWeight={500} id="transition-modal-description" sx={{ mt: 2 }}>
                Voulez-vous annuler la commande ?
              </Typography>
              <Typography textAlign={'center'} id="transition-modal-description" sx={{ mt: 2 }}>
                Voulez-vous vraiment quitter le règlement ? Les billets que vous
                avez sélectionnés ne seront peut-être plus disponibles
                ultérieurement.
              </Typography>
              <Box
                sx={{ width: "100%", display: "flex", justifyContent: "center", columnGap: 2 }}
              >
                <CustomButton type={'secondaire'} buttonText={'rester'} onClick={() => {
                  setOpen(false);
                }} />
                <CustomButton type={'primaire'} buttonText={'Annuler'} onClick={() => {
                  window.location.reload();
                }} />


              </Box>
            </Stack>

          </Box>
        </Fade>
      </Modal>
      {loadingF ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            bgcolor: "white",
            borderRadius: " 10px",
            height: '100%',
            zIndex: 1,
          }}
        >
          <Grid container>
            {/** info de la commande */}
            <Grid item xs={12} sm={8}>
              <Grid container>
                <Grid item xs={12}>
                  <Stack padding={1} direction="row">
                    <IconButton onClick={handleOpen}>
                      <Iconify
                        icon="solar:close-circle-outline"
                        sx={{ width: 24, height: 24 }}
                      />
                    </IconButton>
                    <Stack
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={50}
                        textAlign="center"

                      >
                        Commander
                      </Typography>
                      <Timer />
                    </Stack>
                  </Stack>

                  <Divider />
                </Grid>
                {/** information de facturation et payer avec */}
                {

                  <Grid
                    sx={{ overflowX: "auto", overflowY: "auto" }}
                    item
                    xs={12}
                    paddingX={{ xs: 5, lg: 10 }}
                    paddingY={2}
                    maxHeight={{ xs: 2, sm: '80vh', md: 580, lg: 588, xl: 588 }}
                  >
                    <Stack spacing={5} paddingY={2}>
                      {/** information billing */}
                      <Stack spacing={2}>
                        <Typography
                          fontSize={18}
                          fontWeight={500}
                        >
                          Informations de facturation
                        </Typography>
                        <Stack direction={'row'} spacing={2}>
                          <TextField
                            disabled={loading}
                            value={nomField}
                            required
                            onChange={(e) => setNom(e.target.value)}
                            fullWidth
                            label="Nom"
                            size="medium"
                            error={fieldError && nomField === "" ? true : false}
                            helperText={fieldError && nomField === "" ? 'Le nom de famille est requis' : ''}
                          />
                          <TextField
                            disabled={loading}
                            value={prenomField}
                            onChange={(e) => setPrenom(e.target.value)}
                            required
                            fullWidth
                            label="Prenom"
                            error={fieldError && prenomField === "" ? true : false}
                            helperText={fieldError && prenomField === "" ? "Le prénom est requis" : ''}
                          />
                        </Stack>
                        <Stack direction={'row'} spacing={2}>
                          <TextField
                          required
                            disabled={loading || user}
                            type="email"
                            value={emailField}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            label="Email"
                            error={fieldError && emailField === "" ? true : false}
                            helperText={fieldError && emailField === "" ? "Veuillez saisir une adresse email valide" : ''}
                          />
                          {
                            !user && <TextField
                            required
                              disabled={loading}
                              value={confirmEmailField}
                              onChange={(e) => setConfirmEmail(e.target.value)}
                              fullWidth
                              label="Confirmer l'email "
                              error={fieldError && confirmEmailField === "" ? true : false}
                              helperText={fieldError && confirmEmailField === "" ? "Merci de remplir ce champs" : ''}
                            />
                          }
                        </Stack>
                        <FormControlLabel
                          control={<Checkbox defaultChecked />}
                          label={<Typography color={"GrayText"} variant="body2">Tenez-moi au courant des autres événements et des nouvelles de cet organisateur.</Typography>}
                        />

                        <FormControlLabel
                          control={<Checkbox defaultChecked />}
                          label={<Typography color={"GrayText"} variant="body2">Envoyez-moi des e-mails sur les meilleurs événements ayant lieu dans mes environ ou en ligne.</Typography>}
                        
                        />
                      </Stack>
                      {/** Promo code */}
                      <Stack>
                        {
                          addCode ?
                            <Stack spacing={1}
                              direction="row"
                              justifyContent="left" alignItems={'center'}>
                              {
                                codeCheck.valid ? <Typography sx={{ color: 'green' }} variant="caption">{codeCheck.message}</Typography> : !codeCheck.valid ? <Typography sx={{ color: 'red' }} variant="caption">{codeCheck.message}</Typography> : null
                              }
                              <TextField placeholder="Entrer votre code" label='Promo code' disabled={loading} size="medium" fullWidth value={discountField}
                                onChange={(e) => setDiscount(e.target.value)} />
                              <CustomButton disabled={loading} size="medium" type={'primaire'} buttonText={'Appliquer'} onClick={handleVerifyPromoCode} />
                            </Stack>
                            :
                            <Stack spacing={1}
                              direction="row"
                              justifyContent="left" alignItems={'center'}>
                              <Typography color={'GrayText'} variant="caption">Vous avez un code de réduction ?</Typography>
                              <Button
                                onClick={() => setAddCode(true)}
                                variant="text"
                                size="small"
                                sx={{
                                  fontSize: 12,
                                  textTransform: 'initial',
                                  border: '2px solid transparent',
                                  color: '#5E17EB',
                                  backgroundColor: 'transparent',
                                  borderRadius: '7px',
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                    color: '#5E17EB',
                                    borderColor: 'transparent',
                                  },
                                }}
                              >
                                cliquez-ici
                              </Button>
                            </Stack>

                        }
                      </Stack>
                      {/** Pay with */}

                      {reduction && (montant - reduction.value) === 0 ? <></> : montant === 0 ? <></> :
                        <Stack spacing={2}>
                                        <Typography fontSize={18}
                                          fontWeight={500}>
                                          Payer avec
                                        </Typography>
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          value={moyenPaie}
                                          name="radio-buttons-group"
                                          onChange={(e) => {
                                            handleRadioChange(e);
                                          }}
                                        >
                                          <Stack spacing={2}>
                                            <Stack onClick={() => setPaymentWay(0)} sx={{ borderRadius: '10px', border: `1px solid gainsboro`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                                              <FormControlLabel sx={{ alignItems: 'center' }} value={0} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                                                <Box sx={{ alignItems: 'center', display: 'flex' }}>Mobile Money & Wave</Box>
                                              </Stack>} />
                                              <Stack direction={'row'} spacing={1}>
                                                <Box
                                                  component="img"
                                                  src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                                                  onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                                                  loading="lazy"
                                                  decoding="async"
                                                  srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown.png?alt=media&token=58e2969c-a636-488e-b638-b27d0fec4459://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}
                        
                                                  sx={{
                                                    // aspectRatio: "16 / 9",
                                                    objectFit: "cover",
                                                    width: "35px",
                                                    height: "28px",
                                                    display: "block",
                                                    bgcolor: "#f2f2f2",
                                                    borderRadius:'5px',
                                                    transition: "opacity .3s ease",
                                                  }}
                                                />
                                                <Box
                                                  component="img"
                                                  src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                                                  onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                                                  loading="lazy"
                                                  decoding="async"
                                                  srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-3.png?alt=media&token=9855e697-2621-47eb-8c52-b33b1fee8433://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}
                        
                                                  sx={{
                                                    // aspectRatio: "16 / 9",
                                                    objectFit: "cover",
                                                    width: "35px",
                                                    height: "28px",
                                                    display: "block",
                                                    borderRadius:'5px',
                                                    bgcolor: "#f2f2f2",
                                                    transition: "opacity .3s ease",
                                                  }}
                                                />
                                                <Box
                                                  component="img"
                                                  src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                                                  onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                                                  loading="lazy"
                                                  decoding="async"
                                                  srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-2.png?alt=media&token=1143cc52-69d1-4509-b1a4-cc13a62eb97f://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}
                        
                                                  sx={{
                                                    // aspectRatio: "16 / 9",
                                                    objectFit: "cover",
                                                    width: "35px",
                                                    height: "28px",
                                                    display: "block",
                                                    borderRadius:'5px',
                                                    bgcolor: "#f2f2f2",
                                                    transition: "opacity .3s ease",
                                                  }}
                                                />
                                                <Box
                                                  component="img"
                                                  src={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'}
                                                  onError={'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2Fpreview.png?alt=media&token=8580a57d-7522-4ee3-8335-efc4a1a9261a'}
                                                  loading="lazy"
                                                  decoding="async"
                                                  srcSet={`${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 1x, ${'https://firebasestorage.googleapis.com/v0/b/event-86cbf.appspot.com/o/imageChoptonticket%2FUnknown-4.png?alt=media&token=adf95775-3ae3-4aa2-b288-25a3c84865ce'} 2x`}
                        
                                                  sx={{
                                                    // aspectRatio: "16 / 9",
                                                    objectFit: "cover",
                                                    width: "35px",
                                                    height: "28px",
                                                    display: "block",
                                                    borderRadius:'5px',
                                                    bgcolor: "#f2f2f2",
                                                    transition: "opacity .3s ease",
                                                  }}
                                                />
                                              </Stack>
                        
                                            </Stack>
                                            <Stack onClick={() => setPaymentWay(1)} sx={{ borderRadius: '10px', border: `1px solid gainsboro`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                                              <FormControlLabel sx={{ alignItems: 'center' }} value={1} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                                                <Box sx={{ alignItems: 'center', display: 'flex' }}>Carte de débit ou de crédit</Box>
                                              </Stack>} />
                                              <Iconify
                                                icon="bi:credit-card-2-back"
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            </Stack>
                                            <Stack onClick={() => setPaymentWay(2)} sx={{ borderRadius: '10px', border: `1px solid gainsboro`, cursor: 'pointer' }} direction={'row'} spacing={1} justifyContent={'space-between'} alignItems={'center'} padding={1}>
                                              <FormControlLabel sx={{ alignItems: 'center' }} value={2} control={<Radio />} label={<Stack justifyContent={'space-between'} direction={'row'} spacing={1}>
                                                <Box sx={{ alignItems: 'center', display: 'flex' }}>PayPal</Box>
                                              </Stack>} />
                                              <Iconify
                                                icon="logos:paypal"
                                                sx={{ width: 30, height: 30 }}
                                              />
                                            </Stack>
                                          </Stack>
                                        </RadioGroup>
                        
                                      </Stack>}

                      {/** payment bouton */}
                      <Stack spacing={2}>
                        <Typography variant="body2" color={'GrayText'}>En sélectionnant Commander, j'accepte les Conditions générales du service de choptonticket</Typography>
                        <CustomButton fullWidth loading={loading || procedCheckCP} disabled={loading} type={'primaire'} buttonText={'Comfirmer la commande'} onClick={payV2} />
                      </Stack>
                      <Stack spacing={2}>
                        <Divider />
                        <Typography variant="caption" color={'GrayText'}>Realise par Choptonticket</Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                }

                {/** Bouton de commander 
                <Grid item xs={12}>
                  <Divider />
                  <Stack padding={2} justifyContent={'center'} alignItems={'center'}>
                    {
                      procedCheckCP ? <CustomButton fullWidth disabled={loading} type={'primaire'} buttonText={'Comfirmer la commande'} onClick={payV2} /> : loading ? <CircularProgress /> : <CustomButton fullWidth disabled={loading} type={'primaire'} buttonText={'Comfirmer la commande'} onClick={payV2} />
                    }

                  </Stack>
                </Grid> */}
              </Grid>
            </Grid>
            {/** resumé de la commande */}
            <Grid item xs={12} sm={4} sx={{ borderLeft: " 1px solid gainsboro", borderRadius: " 10px", }}>
              <Grid container>
                <Grid item xs={12}>
                  <Card elevation={0}>
                    {event && (
                      <CardMedia
                        component="img"
                        sx={{ width: "100%", objectFit: "cover" }}
                        height="200"
                        image={event.idVisuel}
                        title="green iguana"
                      />
                    )}
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Stack spacing={2} padding={2}>
                    <Typography fontSize={17} fontWeight={500} >Résumé de la commande</Typography>
                    {ticketsList.map((billet, index) => (
                      <Box color="#999999">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography>
                            {billet.quantite}x {billet.nom}
                          </Typography>
                          <Typography>{shortNumber(billet?.prix)} CFA</Typography>
                        </Stack>
                      </Box>
                    ))}

                    <Divider />
                    {
                      (moyenPaie === 1 || moyenPaie === 2 || reduction) &&
                      <>
                        <Stack direction="row" justifyContent="space-between">
                          <Typography color="#999999">Sous-total</Typography>
                          <Typography color="#999999">{shortNumber(montant)} CFA</Typography>
                        </Stack>
                        {(moyenPaie === 1 || moyenPaie === 2) && (
                          <>

                            <Stack direction="row" justifyContent="space-between">
                              <Typography color="#999999">Frais</Typography>
                              <Typography color="#999999">{reduction ? shortNumber((montant - reduction.value) * fee / 100) : shortNumber(montant * fee / 100)} CFA</Typography>
                            </Stack>
                          </>

                        )}

                        {reduction && (
                          <Stack color="#999999" direction="row" justifyContent="space-between">
                            <Typography>Réduction</Typography>
                            <Typography>
                              {shortNumber(reduction.value)} CFA
                            </Typography>
                          </Stack>
                        )}
                        <Divider />
                      </>
                    }

                    <Stack direction="row" justifyContent="space-between">
                      <Typography fontSize={17} fontWeight={500}>Total à payer</Typography>
                      <Typography fontSize={17} fontWeight={500}>
                        {reduction ? shortNumber(montant - reduction.value + ((montant - reduction.value) * fee / 100)) : shortNumber(montant + (montant * fee / 100))} CFA
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
}
